import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { scheduleType } from 'appConstants';

const ScheduleTypesField: React.FC = () => {
	const { report } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');

	const scheduleNames = scheduleType
		.filter((el) => report?.scheduleTypes.includes(el.scheduleTypeID))
		.map((el) => t(el.scheduleTypeName))
		.join(', ');

	return <FullInfoField label="scheduleTypeLabel" value={scheduleNames} />;
};

export default ScheduleTypesField;
